import React, { useState, useRef } from 'react';
import { Image as ImageIcon, Upload, Download } from 'lucide-react';
import './ToolsCommon.css';

const PDFToImages = () => {
  const [images, setImages] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      await convertPDFToImages(file);
    }
  };

  const convertPDFToImages = async (file) => {
    setIsProcessing(true);
    setImages([]);

    try {
      // Note: This is a simplified version. For production, use pdf.js library
      alert('PDF to Images conversion requires the pdf.js library. This is a demo showing the UI. For full functionality, integrate pdf.js library in production.');

      // Demo: Create placeholder images
      const demoImages = Array.from({ length: 3 }, (_, i) => ({
        id: i,
        dataUrl: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9Ijg1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjAwIiBoZWlnaHQ9Ijg1MCIgZmlsbD0iI2Y5ZmFmYiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjI0IiBmaWxsPSIjNmI3MjgwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5QYWdlICcgKyAoaSArIDEpICsgJzwvdGV4dD48L3N2Zz4='
      }));

      setImages(demoImages);
    } catch (error) {
      console.error('Error converting PDF:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const downloadImage = (dataUrl, index) => {
    const link = document.createElement('a');
    link.download = `page_${index + 1}.png`;
    link.href = dataUrl;
    link.click();
  };

  const downloadAllImages = () => {
    images.forEach((img, index) => {
      setTimeout(() => downloadImage(img.dataUrl, index), index * 200);
    });
  };

  return (
    <div className="tool-container">
      <div className="tool-content-wrapper">
        <div className="tool-header">
          <ImageIcon size={48} className="tool-icon" />
          <h1 className="tool-title">PDF to Images Converter</h1>
          <p className="tool-subtitle">Extract pages from PDF as images</p>
        </div>

        <div className="tool-panel">
          <div className="tool-section">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileSelect}
              accept="application/pdf"
              style={{ display: 'none' }}
            />
            <button
              onClick={() => fileInputRef.current.click()}
              className="tool-button primary"
              style={{ width: '100%' }}
            >
              <Upload size={20} />
              Select PDF File
            </button>
          </div>

          {isProcessing && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
              Processing PDF...
            </div>
          )}

          {images.length > 0 && (
            <>
              <div className="tool-section">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <label className="tool-label" style={{ marginBottom: 0 }}>Extracted Pages ({images.length})</label>
                  <button onClick={downloadAllImages} className="tool-button secondary" style={{ padding: '8px 16px' }}>
                    <Download size={16} />
                    Download All
                  </button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
                  {images.map((image, index) => (
                    <div key={image.id} style={{ border: '2px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden' }}>
                      <img
                        src={image.dataUrl}
                        alt={`Page ${index + 1}`}
                        style={{ width: '100%', display: 'block' }}
                      />
                      <div style={{ padding: '12px', background: '#f9fafb', textAlign: 'center' }}>
                        <button
                          onClick={() => downloadImage(image.dataUrl, index)}
                          className="tool-button secondary"
                          style={{ padding: '8px 16px', fontSize: '14px', width: '100%' }}
                        >
                          <Download size={14} />
                          Page {index + 1}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ marginTop: '24px', padding: '16px', background: '#fef3c7', borderRadius: '12px', fontSize: '14px', color: '#92400e' }}>
                <strong>Note:</strong> This is a demo interface. For production use, integrate the pdf.js library for actual PDF rendering and conversion.
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PDFToImages;
